<template>
    <Dialog
        v-model:visible="exportDialog"
        :style="{
            maxWidth: '600px',
            minWidth: '400px',
            width: '100%',
            marginRight: '20px',
            marginLeft: '20px',
        }"
        :modal="true"
        @hide="closeDialog"
    >
        <template #header>
            <div class="font-medium text-gray-700 text-xl mb-4">
                Exportar envios
            </div>
        </template>
        <div class="min-h-[200px] py-4 px-7">
            <div v-if="$page.props.user.tipo === 'super_admin'">
                <div class="text-gray-700">Selecciona sucursal:</div>
                <Dropdown
                    v-model="selectedClient"
                    :options="clients"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Sucursales"
                    class="mb-3"
                />
            </div>
            <div>
                <div class="text-gray-700">
                    Selecciona el periodo de tiempo a exportar:
                </div>
                <Dropdown
                    v-model="selectedRange"
                    :options="ranges"
                    optionLabel="name"
                    placeholder="Rango de tiempo"
                    @change="handleRangeChange"
                    class="mb-2"
                />
            </div>
            <div
                v-if="selectedRange?.code === 'custom'"
                class="flex flex-col md:flex-row space-y-2 md:space-y-0 space-x-0 md:space-x-2"
            >
                <div class="flex flex-col">
                    <label for="start-date" class="text-gray-700">Incio</label>
                    <Calendar
                        id="start-date"
                        v-model="customRange.start"
                        :showIcon="true"
                        @date-select="handleDateChange"
                    />
                </div>
                <div class="flex flex-col">
                    <label for="end-date">Fin</label>
                    <Calendar
                        id="end-date"
                        v-model="customRange.end"
                        :showIcon="true"
                        @date-select="handleDateChange"
                    />
                </div>
            </div>
        </div>

        <template #footer>
            <div class="flex justify-end">
                <Button variant="dismissive" @click="closeDialog">
                    Cancelar
                </Button>
                <Button
                    :disabled="!optionSelected"
                    @click="handleExport"
                    :loading="loading"
                >
                    <div class="flex items-center space-x-2">
                        <Icon size="15">
                            <FileExcel />
                        </Icon>
                        <span>Exportar</span>
                    </div>
                </Button>
            </div>
        </template>
    </Dialog>
</template>

<script>
import pickBy from "lodash/pickBy";
import axios from "axios";
import Button from "@/shared/Button.vue";
import { Icon } from "@vicons/utils";
import { FileExcel } from "@vicons/fa";

export default {
    name: "ExportDialog",
    components: {
        Button,
        Icon,
        FileExcel,
    },
    props: {
        exportDialog: Boolean,
        clientes: Object,
    },
    data() {
        return {
            selectedClient: null,
            ranges: [
                { name: "Ultimas 24 horas", code: "last_day" },
                { name: "Ultima semana", code: "last_week" },
                { name: "Ultimo mes", code: "last_month" },
                { name: "Ultimos 6 meses", code: "last_semester" },
                { name: "Personalizado", code: "custom" },
            ],
            selectedRange: null,
            customRange: {
                start: null,
                end: null,
            },
            optionSelected: false,
            loading: false,
        };
    },
    computed: {
        clients() {
            let clients = Object.keys(this.clientes).map((id) => ({
                id: parseInt(id),
                name: this.clientes[id]["nombre"].toUpperCase(),
            }));
            clients.unshift({ id: "todos", name: "TODOS" });
            return clients;
        },
    },
    methods: {
        handleRangeChange() {
            if (this.selectedRange !== null) {
                if (this.selectedRange.code === "custom") {
                    this.optionSelected = false;
                    this.customRange = { start: null, end: null };
                } else {
                    this.optionSelected = true;
                }
            } else {
                this.optionSelected = false;
                this.customRange = { start: null, end: null };
            }
        },
        handleDateChange() {
            if (
                this.customRange.start !== null &&
                this.customRange.end !== null
            ) {
                this.optionSelected = true;
            }
        },
        handleExport() {
            this.loading = true;
            axios
                .get("/envios/exportar", {
                    responseType: "blob",
                    params: pickBy({
                        client_id: this.selectedClient,
                        range: this.selectedRange.code,
                        custom_range: [
                            this.customRange.start,
                            this.customRange.end,
                        ],
                    }),
                })
                .then((res) => {
                    console.log(res);
                    let blob = new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    let downloadXls = document.createElement("a");
                    downloadXls.href = window.URL.createObjectURL(blob);
                    downloadXls.download = `listado_envios_${Date.now()}.xls`;
                    downloadXls.click();
                    this.loading = false;
                    this.closeDialog();
                })
                .catch((err) => {
                    console.error(err);
                    this.$emit("dispatchNotification", {
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        detail: "Intenta más tarde",
                        life: 3000,
                    });
                    this.loading = false;
                });
        },
        closeDialog() {
            this.selectedClient = null;
            this.selectedRange = null;
            this.loading = false;
            (this.customRange = {
                start: null,
                end: null,
            }),
                (this.optionSelected = false);
            this.$emit("hideDialog");
        },
    },
};
</script>
